import React from 'react';

class BottomStop extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="bottom-stop"></div>
        );
    }
}

export default BottomStop;



// WEBPACK FOOTER //
// D:/Workarea/iota.org/documentation/src/components/atoms/BottomStop.js